const setEnvVarsToSession = async () => {
    const envsRes = await fetch('/api/envs');

    if (envsRes.ok) {
        const envs = await envsRes.json();

        for (const key in envs) {
            if (Object.prototype.hasOwnProperty.call(envs, key)) {
                const env = envs[key];
                sessionStorage.setItem(key, env);
            }
        }
    } else {
        console.warn("Envs couldn't be fetched. Each env will be fetched individually when needed");
    }
};

export default setEnvVarsToSession;
